import { motion } from "framer-motion";
import { Cpu, Map, Wrench, Gauge } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    title: "Advanced Diagnostics",
    icon: Cpu,
    text: "Dealer-level diagnostic platforms — including BMW ISTA+ — read every module in your car. Fault codes are traced to their root cause, never masked with parts-darting.",
  },
  {
    num: "02",
    title: "BMW Navigation Map Conversion",
    icon: Map,
    text: "Japanese-import BMW with a nav system stuck on Japan? We convert the head unit to New Zealand maps, language and radio bands — full NZ navigation, FSC codes and iDrive features restored.",
  },
  {
    num: "03",
    title: "Servicing & Repair",
    icon: Wrench,
    text: "Scheduled servicing, brakes, suspension, clutches and timing — OEM or better parts, torque-wrench discipline, and a written report you can actually understand.",
  },
  {
    num: "04",
    title: "Performance",
    icon: Gauge,
    text: "From cooling and intake work to stage-one calibrations, we unlock what the factory left on the table — safely, measurably, and within your engine's limits.",
  },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32" data-testid="manifesto-section">
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        className="font-mono text-xs uppercase tracking-[0.3em] text-amber-500"
      >
        The Manifesto
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ delay: 0.1 }}
        className="mt-4 max-w-3xl font-display text-4xl uppercase leading-[0.95] tracking-tight text-slate-50 sm:text-5xl lg:text-6xl"
      >
        Four disciplines. One standard: zero guesswork.
      </motion.h2>

      <div className="mt-16 grid grid-cols-1 border-l border-t border-white/5 sm:grid-cols-2 lg:grid-cols-4">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.12, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="group border-b border-r border-white/5 p-8 transition-colors duration-300 hover:bg-[#12151C]"
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <div className="flex items-start justify-between">
              <span className="font-display text-5xl text-slate-700 transition-colors duration-300 group-hover:text-amber-600">
                {c.num}
              </span>
              <c.icon size={22} className="mt-2 text-slate-600 transition-colors duration-300 group-hover:text-amber-500" />
            </div>
            <h3 className="mt-8 text-xl font-bold text-slate-100 sm:text-2xl">{c.title}</h3>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">{c.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
